import { render, staticRenderFns } from "./Patchplace.vue?vue&type=template&id=5341f97a&"
import script from "./Patchplace.vue?vue&type=script&lang=js&"
export * from "./Patchplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports